module.exports = __webpack_public_path__ + "img/35ne.bb64ddac.svg";